module.exports = __webpack_public_path__ + "img/ics_o_document_red.d24e094a.svg";